import Splide from '@splidejs/splide';

const productSlider = {
    _slider: null,
    timeout: false,
    delay: 250,

    init: function () {
        let self = this;

        self._sliderCreate();
    },

    _sliderCreate() {
        let self = this;
        self._slider = new Splide( '.js-product-slider.splide', {
                type: 'loop',
                speed: 800,
                accessibility: true,
                arrows: false,
                keyboard: true,
                autoplay: true,
                pagination: false,
            }
        ).mount();

        self._update();
        self._initClickEvent();
        self._openGallery();
    },

    _destroy() {
        let self = this;
        self._destroyButtonsEvent();
        self._slider.destroy(true);
        self._slider = null;
    },

    _initClickEvent() {
        let self = this;

        let nextButton = document.querySelector('.product-slider__nav-next');
        let prevButton = document.querySelector('.product-slider__nav-prev');


        if (nextButton) {
            nextButton.addEventListener('click', self._nextSlide, false);
        }

        if (prevButton) {
            prevButton.addEventListener('click', self._prevSlide, false);
        }

    

    },

    _nextSlide() {
        productSlider._slider.go('>');
    },

    _prevSlide() {
        productSlider._slider.go('<');
    },

    _destroyButtonsEvent() {
        let self = this;

        let nextButton = document.querySelector('.product-slider__nav-next');
        let prevButton = document.querySelector('.product-slider__nav-prev');


        if(nextButton && prevButton) {
            nextButton.removeEventListener('click', self._nextSlide, false);
            prevButton.removeEventListener('click', self._prevSlide, false);
        }
    },

    reInit() {
        let self = this;
        let node = document.querySelector('.js-product-slider');

        if (!node) {
            if (self._slider) {
                self._destroy();

            }

            return;
        }

        if (self._slider && self._slider.root === node) {
            return;
        }

        if (self._slider) {
            self._destroy();
        }

        self.init();
    },

    _update() {
        window.lazyLoadInstance.update();
    },

    _openGallery() {
        let self = this;

        let imgs = document.querySelectorAll('.js-product-slider img');

        imgs.forEach(img => {
            img.onclick = function() {
                window.gallery.galleries[document.querySelector('.js-gallery').dataset.id].openGallery(self._slider.index); 
            }
        })
    }
};


window.productSlider = productSlider;

let slider = document.querySelector('.js-product-slider');
if (slider) {
    window.productSlider.init();

}

document.addEventListener('LokiRequestEnd', function () {
    window.productSlider.reInit();
});


window.addEventListener('resize', function() {
    // clear the timeout
    clearTimeout(productSlider.timeout);
    // start timing for event "completion"
    window.productSlider.timeout = setTimeout(window.productSlider._update(), window.productSlider.delay);
});